export default __webpack_public_path__ + "static/media/no-races.7bdca310.png";